import { createFileRoute } from "@tanstack/react-router";
import { PlaceholderPanel } from "@/components/admin/PlaceholderPanel";

export const Route = createFileRoute("/_authenticated/admin/events")({
  component: () => (
    <PlaceholderPanel
      title="Events & Conferences"
      description="Track industry events, summits, and Medical Insight conferences."
      features={[
        "Event details with venue, date range, banner image",
        "Speakers and agenda blocks",
        "Registration link / external ticketing integration",
        "Sponsor placement per event",
        "Past-events archive with gallery",
      ]}
    />
  ),
});
